import { m } from 'framer-motion'
// @mui
import { styled } from '@mui/material/styles'
import { Stack, Container, Typography } from '@mui/material'

import { varFade, MotionViewport } from '../../components/animate'
import { AWS_CDN_DOMAIN } from 'src/config-global'
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(5, 0),
  },
  marginBottom: -100,
}))

const StyledBackground = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0, // change this value as needed
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: -1,
  backgroundImage: `url(${AWS_CDN_DOMAIN + '/frontend-files/images/medium/background-lines.webp'})`,
  backgroundSize: 'cover',
  backgroundPosition: 'top',

  // Make image top fading in white gradient
  '&::before': {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)',
  },
}))

// ----------------------------------------------------------------------

export default function HomePricingPlans() {
  return (
    <StyledRoot>
      <StyledBackground />
      <Container component={MotionViewport}>
        <Description />
      </Container>
    </StyledRoot>
  )
}

// ----------------------------------------------------------------------

function Description() {
  return (
    <Stack spacing={3} sx={{ mb: 10, textAlign: 'left' }}>
      <m.div variants={varFade().inUp}>
        <Typography component="div" variant="overline" sx={{ mb: 0, color: 'text.disabled' }}>
          Tracking
        </Typography>
      </m.div>

      <m.div variants={varFade().inDown}>
        <Typography variant="h2">Automated Container Tracking</Typography>
      </m.div>

      <m.div variants={varFade().inDown}>
        <Typography sx={{ color: 'text.secondary' }}>
          {' '}
          A single dashboard and API to track all your shipments and containers, and identify containers that need your attention. Cubistics
          is integrated with all major ocean carriers and every single terminal in US and Canada.
        </Typography>
      </m.div>
    </Stack>
  )
}
